import { DOMNode, domToReact, Element } from 'html-react-parser'
import { iconParser } from './icon-parser'
import { linkParser } from './link-parser'
import { tableParser } from './table-parser'
import { imageParser } from './image-parser'
import { macroParser } from './macro-parser'
import { scriptParser } from './script-parser'
import { modalParser } from './modal-parser'
import { dataOnScreenParser } from './data-on-screen-parser'
import { collapseParser } from './collapse-parser'
import { nodeParserOptions } from '../options'
import { bannerParser } from './banner-parser'
import { type JSX } from 'react'

export { iconParser, linkParser, macroParser }

interface BaseParser<K = DOMNode> {
  (
    node: K,
    additionalMacros?: object,
    additionalNodeParsers?: Parser[]
  ): false | void | object | JSX.Element | null | undefined
}

type NodeParser = BaseParser<DOMNode>

export type Parser = BaseParser<Element>

const defaultNodeParsers = [
  imageParser,
  iconParser,
  linkParser,
  macroParser,
  tableParser,
  scriptParser,
  modalParser,
  dataOnScreenParser,
  collapseParser,
  bannerParser,
]

export const nodeParser: NodeParser = (node, additionalMacros = {}, additionalNodeParsers = []) => {
  const nodeParsers = [...additionalNodeParsers, ...defaultNodeParsers]
  const parsedNode = node
  // const parsedNode = (imageParser(node, additionalMacros) as Element) || node

  // React parsers - first one to return a value wins
  for (const nodeParser of nodeParsers) {
    if (typeof nodeParser !== 'function') {
      return null
    }

    const reactifiedNodes = nodeParser(
      parsedNode as Element,
      additionalMacros,
      additionalNodeParsers
    )

    if (reactifiedNodes) {
      return reactifiedNodes
    }
  }
}

export const domParser = (
  nodes: DOMNode[],
  additionalMacros = {},
  additionalNodeParsers: Parser[] = []
) => {
  return domToReact(nodes, {
    ...nodeParserOptions,
    replace: (domnode: any) =>
      nodeParser(domnode as Element, additionalMacros, additionalNodeParsers) ?? domnode,
  })
}
